import { render, staticRenderFns } from "./language-filter.vue?vue&type=template&id=49ab7a90&"
import script from "./language-filter.vue?vue&type=script&lang=js&"
export * from "./language-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports